<template>
  <transition name="dialog-fade">
    <div v-show="visiable" @click.self="showClose && (visiable = false)" class="ee-dialog__container" :style="wrapperStyle">
      <div class="ee-dialog" :style="contentStyle">
        <i v-if="showClose" @click="visiable = false" class="ee-dialog__close-btn text-icon icon-close"></i>
        <div v-if="showHeader && title" class="ee-dialog__header">
          {{title}}
        </div>
        <slot name="header"></slot>
        <div class="ee-dialog__body" :style="bodyStyle">
          <slot></slot>
        </div>
        <div class="ee-dialog__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  const doc = global.document
  export default {
    compName: 'ee-dialog',
    props: {
      value: { // 是否显示
        type: Boolean,
        default: false
      },
      width: { // 显示区宽度
        type: [Number, String],
        default: 800
      },
      top: {  // 距离浏览器显示区顶部的距离百分比, 默认 15%, 接收值格式: 15 或 '15%'
        type: [Number, String],
        default: 15
      },
      title: {
        type: String
      },
      bodyStyle: {
        type: Object
      },
      showClose: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      showHeader () {
        return this.title || this.showClose
      },
      wrapperStyle () {
        return {
          'z-index': this.maxZIndex()
        }
      },
      contentStyle () {
        const width = typeof this.width === 'string' ? this.width : `${this.width}px`
        const top = typeof this.top === 'string' ? this.top : `${this.top}%`
        return {
          width,
          top
        }
      }
    },
    methods: {
      maxZIndex () {
        if (!global.MAX_Z_INDEX) {
          global.MAX_Z_INDEX = 900
        }
        return global.MAX_Z_INDEX++
      },
      handleToggle () {
        if (this.visiable) {
          this.bodyCurrntStyle = doc.body.getAttribute('style')
          doc.body.setAttribute('style', 'overflow:hidden;')
          this.$emit('open')
        } else {
          this.$emit('close')
          doc.body.setAttribute('style', this.bodyCurrntStyle)
        }
      }
    },
    watch: {
      value (val) {
        this.visiable = val
        this.handleToggle()
      },
      visiable (val) {
        this.$emit('input', val)
      }
    },
    mounted () {
      this.handleToggle()
    },
    destroyed () {
      try {
        doc.setAttribute('style', this.bodyCurrntStyle)
      } catch (err) {}
    },
    data () {
      return {
        bodyCurrntStyle: '',
        visiable: this.value
      }
    }
  }
</script>
<style src="../style/dialog.css"></style>



// WEBPACK FOOTER //
// src/packages/dialog/Dialog.vue?dbf39520